export const neutral = {
  black: '#000000',
  50: '#090909',
  100: '#121212',
  150: '#1C1C1C',
  200: '#252525',
  250: '#2E2E2E',
  300: '#373737',
  350: '#404040',
  400: '#494949',
  450: '#535353',
  500: '#5B5B5B',
  550: '#6C6C6C',
  600: '#7C7C7C',
  650: '#8D8D8D',
  700: '#9D9D9D',
  750: '#ADADAD',
  800: '#BEBEBE',
  850: '#CECECE',
  900: '#DEDEDE',
  950: '#EFEFEF',
  975: '#F7F7F7',
  990: '#FCFCFC',
  white: '#FFFFFF',
} as const;
